import { ContentType } from 'services/data-manager/types';

import { MdsCallKeys, RBTemplates } from '../reducer.types';

export default {
    name: RBTemplates.Search,
    properties: {},
    rails: [
        {
            hasNext: true,
            id: 'search-channels',
            layout: 'Landscape',
            name: 'SCREEN_SEARCH_CHANNELS',
            properties: {
                limit: '20',
                visible: 'true',
                ContentType: ContentType.ChannelItem,
                MDS_Call: MdsCallKeys.CHANNELS,
            },
            sections: [],
            title: 'SCREEN_SEARCH_CHANNELS',
        },
        {
            hasNext: false,
            id: 'search-programs',
            layout: 'Landscape',
            name: 'SCREEN_SEARCH_TV_PROGRAMS',
            properties: {
                limit: '20',
                visible: 'true',
                ContentType: ContentType.SearchProgram,
                MDS_Call: MdsCallKeys.SEARCH,
            },
            sections: [],
            title: 'SCREEN_SEARCH_TV_PROGRAMS',
        },
        {
            hasNext: false,
            id: 'search-catchup',
            layout: 'Landscape',
            name: 'SCREEN_SEARCH_CU',
            properties: {
                limit: '20',
                visible: 'true',
                ContentType: ContentType.SearchCatchup,
                MDS_Call: MdsCallKeys.SEARCH,
            },
            sections: [],
            title: 'SCREEN_SEARCH_CU',
        },
        {
            hasNext: false,
            id: 'search-vod',
            layout: 'Landscape',
            name: 'SCREEN_SEARCH_MOVIES',
            properties: {
                limit: '20',
                visible: 'true',
                ContentType: ContentType.SearchVod,
                MDS_Call: MdsCallKeys.SEARCH,
            },
            sections: [],
            title: 'SCREEN_SEARCH_MOVIES',
        },
    ],
    targets: [],
    title: 'Search Mobile',
};
